import { QuestionStep } from '../QuestionStep';
import { ChoiceGrid } from './_shared';
import {
  NAV_IMPORTANCE_OPTIONS,
  STEPS,
  type QuestionnaireAnswers,
} from '../questions';

interface NavImportanceStepProps {
  answers: QuestionnaireAnswers;
  onChange: (next: Partial<QuestionnaireAnswers>) => void;
}

export function NavImportanceStep({ answers, onChange }: NavImportanceStepProps) {
  const step = STEPS.find((s) => s.id === 'nav-importance')!;
  return (
    <QuestionStep step={step}>
      <ChoiceGrid
        options={NAV_IMPORTANCE_OPTIONS}
        value={answers.nav_importance}
        onChange={(v) => onChange({ nav_importance: v })}
        columns={1}
      />
    </QuestionStep>
  );
}
